export default
[
    {
        title:"صيانة كهرباء السيارات",
        desc:"فحص شامل على جميع انظمة السيارة الكهربائية باحدث الاجهزة و القياسات",
        img:"https://mhesham32cdn.netlify.com/img/elmohandess/services/syanaelectro.jpg",
        exclusive:false,
        advantages:"تحديد العطل واصلاحه على اقصى سرعة",
        discount:false
    },
    {
        title:"صيانة ميكانيكية",
        desc:"فحص الموتور والفيتيس و جميع أنظمة السيارة باحدث الاجهزة و أدوات القياس",
        img:"https://mhesham32cdn.netlify.com/img/elmohandess/services/syanamechanic.jpg",
        exclusive:true,
        advantages:"خدمة توكيل ومصنعيات ورشة",
        discount:false
    },
    {
        title:"تنظيف دورة رشاشات البنزين",
        desc:"الوصول للحالة المثالية من السرعة و تأكل البنزين",
        img:"https://mhesham32cdn.netlify.com/img/elmohandess/services/rshashatbanzen.jpg",
        exclusive:true,
        advantages:"خصم 50% على التنظيف ان صاحبتها صيانة شاملة للسيارة",
        discount:true
    },
    {
        title:"صيانة وتنظيف دروة التكييف بالسيارة",
        desc:"يقوم الجهاز بتنظيف دورة الفريون القديمة من جميع الرواسب وفلترته ذاتيا",
        img:"https://mhesham32cdn.netlify.com/img/elmohandess/services/takeef.jpg",
        exclusive:true,
        advantages:"يوجد خصومات لعملاء مركز الصيانة",
        discount:true
    },
    {
        title:"تركيب جميع كماليات السيارات",
        desc:"وحدات رفع فيشة بفيشة و اجهزة انظار و سنتر و مخادع دى فى دى و شاشات بلوتوث",
        img:"https://mhesham32cdn.netlify.com/img/elmohandess/services/kmalyat.jpg",
        exclusive:true,
        advantages:"خصومات هائلة على قسم الكماليات",
        discount:true
    },
    {
        title:"خدمة غسيل السيارات",
        desc:"غسيل كامل من الداخل والخارج باجود الخامات",
        img:"https://mhesham32cdn.netlify.com/img/elmohandess/services/8assel.gif",
        exclusive:false,
        advantages:"الجودة والأمانة",
        discount:false
    },
    {
        title:"صيانة درجة الفرامل والعفشة",
        desc:"كشف واصلاح و صيانة دورة العفشة و الفرامل",
        img:"https://mhesham32cdn.netlify.com/img/elmohandess/services/3afsha.jpg",
        exclusive:false,
        advantages:"خصومات على قطع غيار و مصنعيات",
        discount:true
    }
];


// WEBPACK FOOTER //
// ./src/data/servicesData.js